import { useDocument } from '@/api/domains/documents';

interface DocumentTitleProps {
  documentId?: string;
  fallback?: string;
}

export const DocumentTitle = ({ documentId, fallback }: DocumentTitleProps) => {
  const { data, isLoading } = useDocument(documentId ?? '', {
    enabled: !!documentId
  });

  if (isLoading) {
    return (
      <span>
        <i className="pi pi-spin pi-spinner" style={{ fontSize: '0.8rem' }} />
      </span>
    );
  }

  return <span>{data?.title || fallback || documentId}</span>;
};
